import React from 'react'
import giftcard from "../../Images/gift-icon.png"
import bannerimg from "../../Images/earning_rewards_banner.png"
import { Link } from 'react-router-dom'
import icon1 from "../../Images/earning_icon1.png"
import icon2 from "../../Images/earning_icon2.png"
import icon3 from "../../Images/earning_icon3.png"
import icon4 from "../../Images/earning_icon4.png"
import icon5 from "../../Images/earning_icon5.png"

const HowEarningRewards = () => {
    return (
        <>
            <section className='howEarningRewards_page'>
                <div className='cust_container'>
                    <div className="top_area">
                        <Link to="/reward" className="backbtn"> <i className="fa-solid fa-arrow-left-long" /></Link>
                        <h4 className="heading">How to earn rewards</h4>
                        <Link to="/my-wallet" className="icon">
                            <img
                                src={giftcard}
                                className="img-fluid"
                                alt="....."
                            />
                        </Link>
                    </div>

                    <div className='conetnt'>
                        <div className="earningRewards_banner">
                            <img src={bannerimg} className='img-fluid' alt='banner' />
                        </div>

                        <div className='earninghowareyou_wrap'>
                            <h4 className='head'>How to Earn Rewards with Neoo Search </h4>
                            <p className='mb-5'>Earning with Neoo Search Business Rewards is simple, smart, and rewarding! Every action you take on the Neoo Search platform helps you grow your business — and earns you valuable reward points.</p>
                            <p className='mb-5'>Start by creating your <strong>Premium NeooCard</strong> in the <strong>Neoo Search</strong>. From there, you’ll earn points every time you add new members, engage in others profile activities, share your business links, or connect with potential clients. You can also earn bonus points for referring others, posting updates, or redeeming special offers available to Premium business users.</p>
                            
                            <div className='member_box'>
                                <div className='icon'>
                                    <img src={icon1} className='img-fluid' alt='..' />
                                </div>
                                <div className='ditails'>
                                    <h6 className='name'>Become a Premium Member </h6>
                                    <p className='mt-2'>Join as a Premium member and get 1,500 points.</p>
                                </div>
                            </div>

                            <div className='member_box'>
                                <div className='icon'>
                                    <img src={icon2} className='img-fluid' alt='..' />
                                </div>
                                <div className='ditails'>
                                    <h6 className='name'>Add to Members </h6>
                                    <p className='mt-2'>Add a Premium NeooCard and earn 500 points for each one.</p>
                                    <p className='mt-2'>Add a NeooCard and earn 250 points for each one.</p>
                                </div>
                            </div>

                            {/* <div className='member_box'>
                                <div className='icon'>
                                    <img src={icon3} className='img-fluid' alt='..' />
                                </div>
                                <div className='ditails'>
                                    <h6 className='name'>Add to Non-member</h6>
                                    <p className='text'>Get 250 points for each member </p>
                                </div>
                            </div> */}

                            <div className='member_box'>
                                <div className='icon'>
                                    <img src={icon4} className='img-fluid' alt='..' />
                                </div>
                                <div className='ditails'>
                                    <h6 className='name'>Profile and Activities </h6>
                                    <p className=''>Earn rewards by engaging with Neoo Search member profiles:</p>

                                    <ul className='mt-2 ml-5'>
                                        <li> Like a profile: +200 points</li>
                                        <li>Call through the profile: +50 points</li>
                                        <li>Contact via WhatsApp: +50 points</li>
                                        <li>Visit the website link: +200 points</li>
                                        <li>Visit social media links: +100 points for each link</li>
                                        <li>View products: +100 points for each product view</li>
                                        <li>Watch profile video: 150 points</li>
                                        <li>Download the PDF profile: +200 points</li>
                                    </ul>

                                    <p className='' style={{ marginTop: 10, marginBottom: 10 }}>Rate the profile</p>
                                    <ul style={{ listStyleType: "circle", marginLeft: 20 }} className='ml-5'>
                                        <li>1 Star: 50 points</li>
                                        <li>2 Star: 100 points</li>
                                        <li>3 Star: 150 points</li>
                                        <li>4 Star: 200 points</li>
                                        <li>5 Star: 250 points</li>
                                    </ul>
                                </div>
                            </div>

                            <div className='member_box'>
                                <div className='icon'>
                                    <img src={icon5} className='img-fluid' alt='..' />
                                </div>
                                <div className='ditails'>
                                    <h6 className='name'>Redeem offers</h6>
                                    <p className='mt-2'>Get 300 points back for each offer you redeem.</p>
                                </div>
                            </div>

                            {/* <div className='Summary_btn'>
                                <button className='btn'>Summary</button>
                            </div> */}

                        </div>


                        {/* <div className='OfferTerms_Conditions'>
                            <h4>Offer Terms Terms & Conditions</h4>
                            <span><i className="fa-solid fa-angle-right"></i></span>
                        </div> */}

                    </div>
                </div>
            </section>
        </>
    )
}

export default HowEarningRewards